"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.clyde.description': '英国男性，充满力量、细腻和幽默。',
};
